<template>
<article :class="[{ '_without-descr': !useDescription }, addClasses]" class="a-research-item">
  <div class="a-research-item__wrapper">
    <div class="a-research-item__date">
      {{ period }}
    </div>
    <h3 v-if="name" class="a-research-item__title" v-html="name"></h3>
    <p v-if="useDescription" v-html="previewText" class="a-research-item__desc"></p>
  </div>
  <div class="a-research-item__links-wrap">
    <a v-if="reportFile" class="a-research-item__link a-arrow-icon" :href="linkToReport || reportFile.src" :title="reportFile.title"
      target="_blank">
      Читать отчет
    </a>
    <a v-if="pressReleaseHref" class="a-research-item__link a-arrow-icon" :href="pressReleaseHref" :title="name"
      target="_blank">
      Пресс-релиз
    </a>
  </div>
</article>
</template>

<script>
export default {
  name: 'ResearchItem',
  props: {
    addClasses: String,
    useDescription: {
      type: Boolean,
      default: true
    },
    reportFile: {
      type: String,
      default: ''
    },
    pressReleaseHref: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    period: {
      type: String,
      default: ''
    },
    previewText: {
      type: String,
      default: ''
    },
    linkToReport: {
      type: String,
      default: ''
    }
  }
}
</script>